import { observer } from 'mobx-react-lite';
import { useGlobalThemeStore } from './use-global-theme-store';
import { ThemeStoreContext } from './theme-store-context';
import { GlobalThemeProvider } from '@cad-arc';
import { useBroadcast } from '~/common/broadcast-channel/use-broadcast';

export const ThemeProvider = observer(({ children }: { children: React.ReactNode }) => {
    const themeStore = useGlobalThemeStore();

    useBroadcast('preferences-notifications', (message) => {
        if (message.type === 'THEME_CHANGED') {
            themeStore.setTheme(message.payload.theme);
        }
    });

    return (
        <ThemeStoreContext.Provider value={{ themeStore }}>
            <GlobalThemeProvider theme={themeStore.theme}>{children}</GlobalThemeProvider>
        </ThemeStoreContext.Provider>
    );
});
